import { Map } from 'immutable';
import {
  FETCH_CART_SUCCESS,
  FETCH_CART_FAIL,
  ADD_PRODUCT_TO_CART_SUCCESS,
  ADD_PRODUCT_TO_CART_FAIL,
  REMOVE_PRODUCT_FROM_CART_SUCCESS,
  REMOVE_PRODUCT_FROM_CART_FAIL,
  DELETE_CART_ROW_SUCCESS,
  DELETE_CART_ROW_FAIL
} from '../actions/actionTypes';

const initialState = Map();

export function cart(state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_CART_SUCCESS:
    case ADD_PRODUCT_TO_CART_SUCCESS:
    case REMOVE_PRODUCT_FROM_CART_SUCCESS:
    case DELETE_CART_ROW_SUCCESS:
      return payload;

    case FETCH_CART_FAIL:
      return initialState;

    case ADD_PRODUCT_TO_CART_FAIL:
    case REMOVE_PRODUCT_FROM_CART_FAIL:
    case DELETE_CART_ROW_FAIL:
      return state;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/cart.js